:host {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  text-align: left;
  opacity: 0;
  width: fit-content;
  transition: opacity 500ms ease-in;
  clip-rule: evenodd;
  fill: none;
  fill-rule: evenodd;
  line-height: 0;
}
@media (prefers-reduced-motion) {
  :host {
    transition: none;
  }

  .notifications::after {
    transition: none;
  }
}

:host(.loaded) {
  opacity: 1;
}
/** General Tones **/
.info {
  --prism-icon-color: var(--prism-color-text-info-base);
}

.success {
  --prism-icon-color: var(--prism-color-text-success-base);
}

.caution {
  --prism-icon-color: var(--prism-color-text-caution-base);
}

.danger {
  --prism-icon-color: var(--prism-color-text-danger-base);
}

.primary {
  --prism-icon-color: var(--prism-color-text-primary-base);
}

.secondary {
  --prism-icon-color: var(--prism-color-text-secondary-base);
}

.primary-inverse,
.secondary-inverse {
  --prism-icon-color: var(--prism-color-text-primary-inverse-base);
}

.primary-brand {
  --prism-icon-color: var(--prism-color-text-brand-primary-base);
}

.secondary-brand {
  --prism-icon-color: var(--prism-color-text-brand-secondary-base);
}
/** @description https://developer.mozilla.org/en-US/docs/Web/CSS/@media/forced-colors aka high contrast for windows **/
@media (forced-colors: active) {
  .icon-source svg {
    /* stylelint-disable-next-line value-keyword-case */
    --prism-icon-color: CanvasText;
  }
}
/** The container that holds the SVG HTML **/
.icon-source {
  display: inline-block;
}
/** The SVG Target **/
.icon-source svg {
  color: var(--prism-icon-color, currentcolor);
  /** When a local path SVG is used a difference is required between stroke and fill **/
  stroke: var(--prism-icon-stroke-color, inherit);
  width: var(--prism-icon-size-width, 1.5rem);
  height: var(--prism-icon-size-height, 1.5rem);
}
/** Sizes **/
/** 12px **/
.size-xxs {
  --prism-icon-size-width: 0.75rem;
  --prism-icon-size-height: 0.75rem;
}
/** 16px **/
.size-xs {
  --prism-icon-size-width: 1rem;
  --prism-icon-size-height: 1rem;
}
/** 24px **/
.size-sm {
  --prism-icon-size-width: 1.5rem;
  --prism-icon-size-height: 1.5rem;
}
/** 32px **/
.size-md {
  --prism-icon-size-width: 2rem;
  --prism-icon-size-height: 2rem;
}
/** 48px **/
.size-lg {
  --prism-icon-size-width: 3rem;
  --prism-icon-size-height: 3rem;
}
/** 72px **/
.size-xl {
  --prism-icon-size-width: 4.5rem;
  --prism-icon-size-height: 4.5rem;
}
/** 96px **/
.size-xxl {
  --prism-icon-size-width: 6rem;
  --prism-icon-size-height: 6rem;
}
/** Notifications **/
.notifications {
  position: relative;
}

.notifications::after {
  content: '';
  @apply absolute block -right-0.5 -bottom-0.5;
  border: 1px solid var(--prism-color-border-primary-inverse-base);
  border-radius: var(--prism-radius-size-full);
  background-color: var(--prism-icon-color-background-dot, var(--prism-color-fill-secondary-base));
  transition: background-color var(--prism-animation-duration-fast) var(--prism-animation-timing-function);
}
/* Dot Size */
.size-xs::after {
  right: 0;
  bottom: 0;
  width: 0.375rem;
  height: 0.375rem;
  border-width: 0.0313rem;
}

.size-sm::after {
  right: 0;
  bottom: 0;
  width: 0.5rem;
  height: 0.5rem;
}

.size-md::after {
  width: 0.75rem;
  height: 0.75rem;
}

.size-lg::after {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
}

.size-xl::after {
  width: 1.5rem;
  height: 1.5rem;
  border-width: 2px;
}

.size-xxl::after {
  width: 1.75rem;
  height: 1.75rem;
  border-width: 2px;
}
/* Dot Status Color */
.notifications.dot-primary::after {
  background-color: var(--prism-color-fill-primary-base);
}

.notifications.dot-secondary::after {
  background-color: var(--prism-color-fill-secondary-base);
}

.notifications.dot-primary-inverse::after,
.notifications.dot-secondary-inverse::after {
  background-color: var(--prism-color-fill-primary-inverse-base);
}

.notifications.dot-success::after {
  background-color: var(--prism-color-fill-success-base);
}

.notifications.dot-danger::after {
  background-color: var(--prism-color-fill-danger-base);
}

.notifications.dot-primary-brand::after {
  background-color: var(--prism-color-fill-brand-primary-base);
}

.notifications.dot-secondary-brand::after {
  background-color: var(--prism-color-fill-brand-secondary-base);
}

.notifications.dot-info::after {
  background-color: var(--prism-color-fill-info-base);
}

.notifications.dot-caution::after {
  background-color: var(--prism-color-fill-caution-base);
}
/* Priority */

.priority-secondary {
  opacity: var(--prism-alpha-secondary);
}

.priority-tertiary {
  opacity: var(--prism-alpha-tertiary);
}

.priority-inactive {
  opacity: var(--prism-alpha-inactive);
}
/* Contained */
.contained {
  border-radius: var(--prism-icon-size-contained-border-radius, 2.5rem);
  padding: var(--prism-icon-spacing-contained-padding);
  border: var(--prism-icon-spacing-border-contained, 1px) solid color-mix(in srgb, var(--prism-icon-color-border-contained) var(--prism-alpha-tertiary-percentage), transparent);
}
/* Contained | Outline Display */
.contained.outline {
  border: var(--prism-icon-spacing-border-contained, 1px) solid
    color-mix(in srgb, var(--prism-icon-color-border-contained, var(--prism-color-border-secondary-base)) var(--prism-alpha-tertiary-percentage), transparent);
}

.contained.outline.high {
  border: var(--prism-icon-spacing-border-contained, 1px) solid
    color-mix(in srgb, var(--prism-icon-color-border-contained, var(--prism-color-border-secondary-base)) var(--prism-alpha-secondary-percentage), transparent);
}

.contained.outline.caution {
  --prism-icon-color-border-contained: var(--prism-color-border-caution-base);
}

.contained.outline.info {
  --prism-icon-color-border-contained: var(--prism-color-border-info-base);
}

.contained.outline.danger {
  --prism-icon-color-border-contained: var(--prism-color-border-danger-base);
}

.contained.outline.primary {
  --prism-icon-color-border-contained: var(--prism-color-border-primary-base);
}

.contained.outline.primary-inverse,
.contained.outline.secondary-inverse {
  --prism-icon-color-border-contained: var(--prism-color-border-primary-inverse-base);
}

.contained.outline.secondary {
  --prism-icon-color-border-contained: var(--prism-color-border-secondary-base);
}

.contained.outline.success {
  --prism-icon-color-border-contained: var(--prism-color-border-success-base);
}

.contained.outline.primary-brand {
  --prism-icon-color-border-contained: var(--prism-color-border-brand-primary-base);
}

.contained.outline.secondary-brand {
  --prism-icon-color-border-contained: var(--prism-color-border-brand-secondary-base);
}
/* Contained | Fill Display Tones | Priority */
.contained.fill.low {
  background-color: var(--prism-icon-color-background-contained, var(--prism-color-material-secondary-base));
}

.contained.fill.low.caution {
  --prism-icon-color-background-contained: var(--prism-color-material-caution-base);
}

.contained.fill.low.info {
  --prism-icon-color-background-contained: var(--prism-color-material-info-base);
}

.contained.fill.low.danger {
  --prism-icon-color-background-contained: var(--prism-color-material-danger-base);
}

.contained.fill.low.primary {
  --prism-icon-color-background-contained: var(--prism-color-material-primary-base);
}

.contained.fill.low.primary-inverse {
  --prism-icon-color-background-contained: var(--prism-color-material-primary-inverse-base);
}

.contained.fill.low.secondary {
  --prism-icon-color-background-contained: var(--prism-color-material-secondary-base);
}

.contained.fill.low.secondary-inverse {
  --prism-icon-color-background-contained: var(--prism-color-material-secondary-inverse-base);
}

.contained.fill.low.success {
  --prism-icon-color-background-contained: var(--prism-color-material-success-base);
}

.contained.fill.low.primary-brand {
  --prism-icon-color-background-contained: var(--prism-color-material-brand-primary-base);
}

.contained.fill.low.secondary-brand {
  --prism-icon-color-background-contained: var(--prism-color-material-brand-secondary-base);
}
/* Contained | Fill Display Tones | Priority */
.contained.fill.high {
  background-color: var(--prism-icon-color-background-contained, var(--prism-color-fill-secondary-base));
}

.contained.fill.high.caution {
  --prism-icon-color-background-contained: var(--prism-color-fill-caution-base);
}

.contained.fill.high.info {
  --prism-icon-color-background-contained: var(--prism-color-fill-info-base);
}

.contained.fill.high.danger {
  --prism-icon-color-background-contained: var(--prism-color-fill-danger-base);
}

.contained.fill.high.primary {
  --prism-icon-color-background-contained: var(--prism-color-fill-primary-base);
}

.contained.fill.high.primary-inverse,
.contained.fill.high.secondary-inverse {
  --prism-icon-color-background-contained: var(--prism-color-fill-primary-inverse-base);
}

.contained.fill.high.secondary {
  --prism-icon-color-background-contained: var(--prism-color-fill-secondary-base);
}

.contained.fill.high.success {
  --prism-icon-color-background-contained: var(--prism-color-fill-success-base);
}

.contained.fill.high.primary-brand {
  --prism-icon-color-background-contained: var(--prism-color-fill-brand-primary-base);
}

.contained.fill.high.secondary-brand {
  --prism-icon-color-background-contained: var(--prism-color-fill-brand-secondary-base);
}
/* 12 */
.xxs.contained {
  --prism-icon-spacing-contained-padding: var(--prism-spacer-size-xs);
}
/* 16 */
.xs.contained {
  --prism-icon-spacing-contained-padding: var(--prism-spacer-size-xs) var(--prism-spacer-size-sm);
}
/* 24 */
.sm.contained {
  --prism-icon-spacing-contained-padding: var(--prism-spacer-size-sm) var(--prism-spacer-size-md);
}
/* 32 */
.md.contained {
  --prism-icon-spacing-contained-padding: var(--prism-spacer-size-md) var(--prism-spacer-size-lg);
}
/* 48 */
.lg.contained {
  --prism-icon-spacing-contained-padding: var(--prism-spacer-size-lg) var(--prism-spacer-size-xxl);
}
/* 72 */
.xl.contained {
  --prism-icon-spacing-contained-padding: var(--prism-spacer-size-xl) var(--prism-spacer-size-xxl);
  --prism-icon-size-contained-border-radius: 3.75rem;
}
/* 96 */
.xxl.contained {
  --prism-icon-spacing-contained-padding: var(--prism-spacer-size-xxl) var(--prism-spacer-size-3xl);
  --prism-icon-size-contained-border-radius: 5rem;
}
